export const BOLLO_IMPORTO = 2; // Euro per fattura
export const BOLLO_SOGLIA = 77.47; // Fatture sopra questa soglia richiedono bollo
export const BOLLO_ACCORPAMENTO_SOGLIA = 5000; // Sotto questa cifra si può accorpare
export const BOLLO_CODICE_TRIBUTO = '2501';

export const SCADENZE_BOLLO = [
  { trimestre: 'Q1', mesi: [1, 2, 3], label: 'Gennaio - Marzo', scadenza: { giorno: 31, mese: 5 } },
  { trimestre: 'Q2', mesi: [4, 5, 6], label: 'Aprile - Giugno', scadenza: { giorno: 30, mese: 9 } },
  { trimestre: 'Q3', mesi: [7, 8, 9], label: 'Luglio - Settembre', scadenza: { giorno: 30, mese: 11 } },
  { trimestre: 'Q4', mesi: [10, 11, 12], label: 'Ottobre - Dicembre', scadenza: { giorno: 28, mese: 2, annoSuccessivo: true } },
];
